<div class="module-page">
    <div class="module-page__group" *ngIf="availableModules && availableModules.length>0">
        <div class="module" *ngFor="let module of availableModules">
            <h2 class="module__name heading">{{ module.name }}</h2>
            <div class="module__description">{{ module.description }}</div>
            <a class="module__action btn btn--basic"href="javascript:void(0)" (click)="onActivateModule(module)">Install</a>
            <a class="module__more-info"*ngIf="module.moreInfo" [href]="module.moreInfo" target="_blank" rel="noopener noreferrer">more info...</a>
        </div>
    </div>
    <div class="module-page__group" *ngIf="activeModules && activeModules.length>0">
        <h3 class="subheading">Already installed</h3>
        <div class="module" *ngFor="let module of activeModules">
            <h2 class="module__name heading">{{ module.name }}</h2>
            <div class="module__description" [innerHTML]="module.description | safeHtml"></div>
            <a class="module__more-info"*ngIf="module.moreInfo" [href]="module.moreInfo" target="_blank" rel="noopener noreferrer">more info...</a>
        </div>
    </div>
</div>